// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Ndpqn","spacer":"_1Zg2h","quantity":"_2nTsg","button":"_3yTiq"};